import { sparql } from '@tpluscode/rdf-string';
export function concat(current, strings, values, {
  wrapTemplate = false,
  newLineSeparator = true
} = {}) {
  let next = sparql(strings, ...values);

  if (wrapTemplate) {
    next = sparql`( ${next} )`;
  }

  if (!current) {
    return next;
  }

  return sparql`${current}${newLineSeparator ? '\n' : ''}
${next}`;
}